import { isFinished } from '@/utils/dictionary'

export const IsFinished = (value: string | number) => {
  const result = isFinished.find(item => item.value === value + '')
  return result ? result.label : ''
}
